import { ZoomSliderResolvingAxisValueEventArgs as ZoomSliderResolvingAxisValueEventArgs_internal } from "./ZoomSliderResolvingAxisValueEventArgs";
var IgrZoomSliderResolvingAxisValueEventArgs = /** @class */ /*@__PURE__*/ (function () {
    function IgrZoomSliderResolvingAxisValueEventArgs() {
        this._implementation = this.createImplementation();
        this._implementation.externalObject = this;
        this.onImplementationCreated();
        if (this._initializeAdapters) {
            this._initializeAdapters();
        }
    }
    IgrZoomSliderResolvingAxisValueEventArgs.prototype.createImplementation = function () {
        return new ZoomSliderResolvingAxisValueEventArgs_internal();
    };
    Object.defineProperty(IgrZoomSliderResolvingAxisValueEventArgs.prototype, "i", {
        /**
         * @hidden
         */
        get: function () {
            return this._implementation;
        },
        enumerable: false,
        configurable: true
    });
    IgrZoomSliderResolvingAxisValueEventArgs.prototype.onImplementationCreated = function () {
    };
    IgrZoomSliderResolvingAxisValueEventArgs.prototype._provideImplementation = function (i) {
        this._implementation = i;
        this._implementation.externalObject = this;
        this.onImplementationCreated();
        if (this._initializeAdapters) {
            this._initializeAdapters();
        }
    };
    Object.defineProperty(IgrZoomSliderResolvingAxisValueEventArgs.prototype, "position", {
        get: function () {
            return this.i.position;
        },
        set: function (v) {
            this.i.position = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrZoomSliderResolvingAxisValueEventArgs.prototype, "value", {
        get: function () {
            return this.i.value;
        },
        set: function (v) {
            this.i.value = v;
        },
        enumerable: false,
        configurable: true
    });
    return IgrZoomSliderResolvingAxisValueEventArgs;
}());
export { IgrZoomSliderResolvingAxisValueEventArgs };
